import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TextIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.5 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.5),
    children: [/*#__PURE__*/jsx("rect", {
      width: "45",
      height: "45",
      x: "1.25",
      y: "1.25",
      rx: "1.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.25 10.25h18M10.25 28.25h27M10.25 19.25h27M10.25 37.25h15"
    })]
  });
};

export { PM2TextIcon };
//# sourceMappingURL=text.js.map
